import { Controller, useForm } from "react-hook-form";
import { PostSuborgFields } from "../../../../interfaces/SuperAdmin/Pages/iDataSuborganizacion";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { iDataOrganizacion } from "../../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { useParams } from "react-router-dom";

const CreateSuborgModal = () => {
  const { idOrganization } = useParams();
  const {
    isCreateSuborgModalOpen,
    toggleCreateSuborgModal,
    isCreatingSuborg,
    suborgCreate,
  } = useSuperAdminSingleOrg();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    register,
  } = useForm<PostSuborgFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: PostSuborgFields) => {
    if (idOrganization) {
      const newData: PostSuborgFields = {
        ...data,
        id_organizacion: idOrganization,
      };
      console.log(newData);

      suborgCreate(newData);
    }
  };

  // Función para cerrar el modal
  const handleClose = () => {
    if (!isCreatingSuborg) {
      reset();
      toggleCreateSuborgModal(false);
    }
  };

  return (
    <Modal
      open={isCreateSuborgModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Nueva suborganización
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombre
          </Typography>
          <Controller
            name="suborganizacion"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.suborganizacion}
                helperText={errors.suborganizacion?.message}
                disabled={isCreatingSuborg}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isCreatingSuborg}
            type="submit"
          >
            Crear
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateSuborgModal;
